// src/pages/AboutUsex/AboutUsex.js

import React from "react";
import { Link } from "react-router-dom";
import "./AboutUsex.css";

import WhyAboutUs from "../../components/WhyAboutUs/WhyAboutUs";
import StatisticsSection from "../../components/StatisticsSection/StatisticsSection";
import FAQ from "../../components/faq/faq";
import Highlights from "../../components/Highlights/Highlights";
// Corrected import path if it's BoardMemberSlider
import BoardMembersSlider from "../../components/BoardMemberSlider/BoardMemberSlider"; 

const AboutUsex = () => {
  return (
    <div className="about-usex-page">
      {/* Hero Section - typically not a scroll target from navbar itself */}
      <header id="hero-aboutusex" className="hero-section-aboutusex">
        <div className="hero-overlay">
          <h1 className="main-headline">Willkommen bei Uns!</h1>
          <p className="hero-subtitle">
            Unser Verein bietet Aktivitäten für jedes Alter und viele Interessen.
          </p>
          <Link to="/contact" className="btn-hero-aboutusex">
            Jetzt Mitglied werden
          </Link>
        </div>
      </header>

      {/* Assign IDs for Navbar scrolling */}
      <div id="why-us-section">
        <WhyAboutUs />
      </div>

      <section id="statistics-section-aboutus" className="content-section">
        <StatisticsSection />
      </section>
      

        <Highlights />

      {/*
      <section id="board-members-section"> 
        <BoardMembersSlider />
      </section>
      */}

      {/* Final Call to Action Section - less common as a direct nav scroll target */}
      <section id="join-us-section-cta" className="join-us-section">
        <div className="container text-center">
          <h2 className="bold-white-title">Werde Teil der Familie!</h2>
          <p className="lead-text-light">
            Schließe dich unserem Verein an und erlebe einzigartige Erlebnisse.
          </p>
          <Link to="/contact" className="btn-join-us">
            Jetzt beitreten
          </Link>
        </div>
      </section>

      <section id="faq-section-aboutus" className="content-section">
        <FAQ />
      </section>
    </div>
  );
};

export default AboutUsex;